import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { headerFooterDataReducer } from "../storage/reducers/HeaderFooterDataReducer";
import { configReducer } from "../storage/reducers/configReducer";
import { contractDetailsReducer } from "../storage/reducers/contractDetailsReducer";
import storage from "redux-persist/lib/storage/session";
import { persistReducer, persistStore } from "redux-persist";
import thunk from "redux-thunk";

const persistConfig = {
  key: "root",
  storage,
};

const rootReducer = combineReducers({
  headerFooterData: headerFooterDataReducer.reducer,
  config: configReducer.reducer,
  contracts: contractDetailsReducer.reducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: [thunk],
});

export const persistor = persistStore(store);
